import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(`${ADMIN_ENDPOINTS.ADMIN_TEAMMATE_DELETE.replace(':teammateId', payload.id)}`, {
      queryParams: { service: 'rapidoo-admin' }
    })
  },

  method() {
    return 'POST'
  },

  format(payload) {
    return {}
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de la suppression du coéquipier",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Coéquipier supprimé avec succès',
      data: raw.data,
    }
  },
}
